import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosConfig from '../../../configs/axios.config';
import axios from 'axios'

//Reducer Thunk
export const getServicesStatus = createAsyncThunk('ServicesStatus/GetServicesStatus', async () => {
    try {
        const response = await axios.create(axiosConfig).get('api/ServicesIT/GetServicesIT')
        if (response.data.success) {
            return response.data.result
        }
        else {
            console.log(response.data)
        }
    }
    catch (error) {
        console.log(error)
    }
})

const ServicesStatusSlice = createSlice({
    name: 'ServicesStatus',
    initialState: {
        dataLoading: [],
        isLoading: true
    },
    reducers: {

    },
    extraReducers: (builder) => {
        builder.addCase(getServicesStatus.fulfilled, (state, action) => {
            state.isLoading = false
            state.dataLoading = action.payload
        })
    }
})

//Reducer
const ServicesStatusReducer = ServicesStatusSlice.reducer

//Selector
export const ServicesStatusSelector = (state) => state.ServicesStatusReducer

//Action export
export const {

} = ServicesStatusSlice.actions

//Export reducer
export default ServicesStatusReducer